import React, { useState } from "react";
import { Button } from "react-bootstrap";
import { RxHamburgerMenu } from "react-icons/rx";
import AdminOffCanvasSidebar from "./AdminOffCanvasSidebar";
import AdminNavList from "./AdminNavList";

const AdminLayout = ({ children }) => {
	const [showSidebar, setShowSidebar] = useState(false);

	return (
		<div className="admin-layout admin-theme">
			<aside className="admin-sidebar d-none d-lg-flex">
				<div className="admin-sidebar-header">Admin Menu</div>
				<AdminNavList />
			</aside>
			<main className="admin-content">
				<div className="admin-mobile-header d-lg-none">
					<Button
						variant="primary"
						onClick={() => setShowSidebar(true)}
						aria-label="Open admin menu"
					>
						<RxHamburgerMenu />
					</Button>
				</div>
				<AdminOffCanvasSidebar
					show={showSidebar}
					handleClose={() => setShowSidebar(false)}
				/>
				{children}
			</main>
		</div>
	);
};

export default AdminLayout;
